export default __webpack_public_path__ + "static/media/preload.e7f1e058.gif";